export default __webpack_public_path__ + "static/media/Andrea_Vera_Arabe.567516df.jpg";